var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.951 0.339912L5.16099 6.90548L2.04902 3.89626C1.58035 3.44307 0.820322 3.44299 0.351566 3.89618C-0.117189 4.34945 -0.117189 5.08429 0.351566 5.53756L4.31222 9.36751C4.53731 9.58517 4.84259 9.7075 5.16091 9.7075C5.16083 9.7075 5.16099 9.7075 5.16091 9.7075C5.47923 9.7075 5.78458 9.58517 6.00968 9.36758L13.6484 1.98136C14.1172 1.5281 14.1172 0.793257 13.6484 0.339989C13.1797 -0.113278 12.4197 -0.113356 11.951 0.339912Z",
    fill: "#6FCF97"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/CheckedIcon.a29df7e3fd4cfe12746b40cd19c4f9e5.svg";
export { ForwardRef as ReactComponent };